export const decodeJWT = (jwt: string) => JSON.parse(window.atob(jwt.split('.')[1]))
